export const API_BILLING_CLAIMS_ATHENA_CREATE =
  'reports/billing-tools-athena/create';
export const API_BILLING_CLAIMS_ATHENA_LIST =
  'reports/billing-tools-athena/list';
